var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5783 46.2667H36.3673C37.7481 46.2667 38.8673 45.1475 38.8673 43.7667V40.0167M28.9063 15.0167H25.1173C23.7366 15.0167 22.6173 16.136 22.6173 17.5167V21.2667M15.7423 13.1417V48.1417C15.7423 50.9032 17.9809 53.1417 20.7423 53.1417H40.7423C43.5038 53.1417 45.7423 50.9032 45.7423 48.1417V13.1417C45.7423 10.3803 43.5038 8.14172 40.7423 8.14172H20.7423C17.9809 8.14172 15.7423 10.3803 15.7423 13.1417Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.8437009732d6024c269aed266a0d4353.svg";
export { ForwardRef as ReactComponent };